import { useEffect, useState } from 'react';
import { getBrandConfig } from '@utils/brandHelper';
import './LoadingBar.css';

export default function LoadingBar({
  targetProgress = 0,  // Target progress (0-100)
  message = "Loading..."
}) {
  const [currentProgress, setCurrentProgress] = useState(0);
  const brandConfig = getBrandConfig();

  // Animate progress gradually
  useEffect(() => {
    if (currentProgress >= targetProgress) return;

    const interval = setInterval(() => {
      setCurrentProgress(prev => {
        if (prev >= targetProgress) {
          clearInterval(interval);
          return targetProgress;
        }
        // Increment by 2% every 30ms for smooth animation
        return Math.min(prev + 2, targetProgress);
      });
    }, 30);

    return () => clearInterval(interval);
  }, [targetProgress, currentProgress]);

  return (
    <div
      className="loading-bar"
      style={{
        backgroundColor: brandConfig.loading.backgroundColor,
        color: brandConfig.loading.textColor
      }}
    >
      <div className="loading-bar-content">
        <h2 className="loading-bar-message">{message}</h2>

        <div className="loading-bar-track">
          <div
            className="loading-bar-fill"
            style={{
              width: `${currentProgress}%`,
              backgroundColor: brandConfig.loading.barColor,
              boxShadow: `0 0 20px ${brandConfig.loading.barGlow}`
            }}
          />
        </div>

        <p className="loading-bar-percentage">{Math.round(currentProgress)}%</p>
      </div>
    </div>
  );
}
